<script lang="ts">
  interface Props {
    override: any;
    event?: boolean;
    hasEvent?: boolean;
  }

  let { override, event = false, hasEvent = false }: Props = $props();
</script>

<div class="astrict" class:event class:override class:hasEvent></div>

<style>
  @media screen and (max-width: 768px) {
    .astrict:not(.override) {
      --width: 10px;
      --offset: calc(var(--width) / 2 * -1);
      position: absolute;
      background-color: var(--altColor);
      aspect-ratio: 1 / 1;
      width: var(--width);
      border-radius: 50%;
      right: var(--offset);
      top: var(--offset);
      border: 1px solid white;
      z-index: 1;
    }

    .astrict:not(.override).event {
      --width: 10px;
      --offset: calc(var(--width) / 2 * -1);
      right: calc(var(--offset) + 6px);
      z-index: 2;
    }

    .astrict:not(.override).hasEvent {
      background-color: var(--holiday);
    }
  }
</style>
